import { render, staticRenderFns } from "./NavbarBreadcrumb.vue?vue&type=template&id=6fd7939b&scoped=true&"
import script from "./NavbarBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./NavbarBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./NavbarBreadcrumb.vue?vue&type=style&index=0&id=6fd7939b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7939b",
  null
  
)

export default component.exports